import React, { useState } from "react"
import { URLS } from "../../_config"
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs"
import Layout from "../layout"
import Icon from "../../components/icons"
import { Link } from "react-router-dom"

const Shop = () => {
    const [activeTab, setActiveTab] = React.useState(1)


    return <Layout>
        <div className="container-fluid" data-aos="fade-up" data-aos-duration="1000">

            <div className="row">
                <div className="col-12">

                    <div className="page-title-box d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-15">
                            <h1 className="mb-0 text-xxl">Shop</h1>
                            <div className="btn-group">
                                <button type="button" className="btn btn-primary dropdown-toggle rate_checker" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Rate Calculator <i className="mdi mdi-chevron-down"></i></button>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" href="#">Polly Rate Checker</a>
                                    <div className="dropdown-item multidropdown">Lender Price Rate Checker
                                        <ul>
                                            <li>
                                                <a href="#">275 BPS</a>
                                            </li>
                                            <li>
                                                <a href="#">200 BPS</a>
                                            </li>
                                            <li>
                                                <a href="#">0 BPS</a>
                                            </li>
                                            <li>
                                                <a href="#">Account</a>
                                            </li>
                                            <li>
                                                <a href="#">Powered by <strong>Lender Price</strong></a>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                                <li className="breadcrumb-item active">Shop</li>
                            </ol>
                        </div>

                    </div>

                </div>
            </div>

            <div className="row">
                <div className="col-sm-3 subscription_leftpanel">
                    <div className="card boxshadow_none mb-0">
                        <div className="card-body py-3">
                            <div className="section-heading pb-3 mb-2">
                                <h2>Filter</h2>
                            </div>
                            <div className="form-group mb-4">
                                <label >Product</label>
                                <select id="formrow-inputState" className="form-control">
                                    <option  >Search Product</option>
                                    <option>...</option>
                                </select>
                            </div>

                            <ul className="filter-option-links d-flex gap-15">
                                <li><a href="#" className="active">All</a></li>
                                <li><a href="#">One Time</a></li>
                                <li><a href="#">Recurring</a></li>
                            </ul>
                            <div className="pt-3">
                                <h5 className="font-size-14">Price:</h5>
                                <input type="range" className="form-control-range w-100" id="formControlRange" />
                                <div className="d-flex justify-content-end">
                                    <p>Max- $400</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="vr-tabs-panel">
                        <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <a className={`nav-link mb-2 ${activeTab == 1 && 'active'}`} id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true" onClick={() => setActiveTab(1)}><span className="tabs-number">1</span> All</a>
                            <a className={`nav-link mb-2 ${activeTab == 2 && 'active'}`} id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false" onClick={() => setActiveTab(2)}><span className="tabs-number">2</span> MLOBox</a>
                            <a className={`nav-link mb-2 ${activeTab == 3 && 'active'}`} id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false" onClick={() => setActiveTab(3)}><span className="tabs-number">3</span> Marketing &
                                Branding</a>
                            <a className={`nav-link ${activeTab == 4 && 'active'}`} id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false" onClick={() => setActiveTab(4)}><span className="tabs-number">4</span> Software</a>
                            <a className={`nav-link ${activeTab == 5 && 'active'}`} id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false" onClick={() => setActiveTab(5)}><span className="tabs-number">5</span> MBS Highway</a>
                            <a className={`nav-link ${activeTab == 6 && 'active'}`} id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false" onClick={() => setActiveTab(6)}><span className="tabs-number">6</span> Loan Pricing</a>
                            <a className={`nav-link ${activeTab == 7 && 'active'}`} id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false" onClick={() => setActiveTab(7)}><span className="tabs-number">7</span> CRM</a>
                            <a className={`nav-link ${activeTab == 8 && 'active'}`} id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false" onClick={() => setActiveTab(8)}><span className="tabs-number">8</span> Website</a>
                            <a className={`nav-link ${activeTab == 9 && 'active'}`} id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false" onClick={() => setActiveTab(9)}><span className="tabs-number">9</span> Coaching</a>
                            <a className={`nav-link ${activeTab == 10 && 'active'}`} id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false" onClick={() => setActiveTab(10)}><span className="tabs-number">10</span> Design</a>
                        </div>
                    </div>
                </div>

                <div className="col-sm-9">
                    <div className="card">
                        <div className="card-body py-3">
                            <div className="section-heading pb-3 mb-2">
                                <h2>All</h2>
                            </div>
                            <div className="processor_listing lender_list subscription-list">
                                <ul>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/01.jpg) no-repeat top left' }}>
 
                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/02.jpg) no-repeat top left' }}>
                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/03.jpg) no-repeat top left' }}>

                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/04.jpg) no-repeat top left' }}>

                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/05.jpg) no-repeat top left' }}>

                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/06.jpg) no-repeat top left' }}>

                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/07.jpg) no-repeat top left' }}>
                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl" style={{ background: 'url(assets/images/my-subcription/08.jpg) no-repeat top left' }}>

                                            </div>
                                            <div className="rocessor_listright subscription-list-cont">
                                                <h4>Custom Business Card</h4>
                                                <p>$100.00</p>
                                                <button type="submit" className="btn btn-light-secondary w-md">Add to Cart</button>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </Layout>
}
export default Shop